import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import InfoIcon from '@material-ui/icons/InfoOutlined';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import WarningIcon from '@material-ui/icons/Warning';

/**
 * Small "info" view, for displaying infos, warning or errors
 */

const styles = theme => ({
  info: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1
  },
  icon: {
    marginRight: theme.spacing.unit
  },
  message: {
    flex: 1
  }
});

const Icon = ({ level, ...props }) => {
  switch (level) {
    case "error":
      return <ErrorIcon color="error" {...props} />;
    case "warning":
      return <WarningIcon color="disabled" {...props} />;
    default:
      return <InfoIcon color="disabled" {...props} />;
  }
}

const Info = ({ level = "info", children, classes, actions }) => (
  <div className={classes.info}>
    <Icon level={level} className={classes.icon} />
    <Typography className={classes.message}>{children}</Typography>
    {actions}
  </div>
)

export default withStyles(styles)(Info);


// WEBPACK FOOTER //
// ./src/components/Info.js